/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum BusinessComponentSoftwareType {
    NA = 0,
    IUS = 1,
    DFS = 2,
    NONISU = 3,
    EXCEPTED = 4,
}
